__turbopack_context__.v({
  "container": "videoSection-module-scss-module__jBMmNG__container",
  "heading": "videoSection-module-scss-module__jBMmNG__heading",
  "video": "videoSection-module-scss-module__jBMmNG__video",
});
